import OdxChip from "../NativeOdx/Odx-Chip";
import {odxIconSets, odxVariants} from "../constants";
import React from "react";
import {TenantLine} from "../../Components/IDMS/Interfaces/ITenantSystem";
import {GuidDisplayNameComponent, simplifyForHtmlId} from "../../Utils/transformer";
import {HubPathRouting} from "../../HubFramework/pathBuilder";
import {IAppConfig} from "../../Components/IDMS/Interfaces/IConfig";


interface ModalTenantManagementTableProps {
    scopes: TenantLine[],
    openEditScopeModal: (scope: TenantLine) => void,
    removeScope: (index: number) => void,
    disabled?: boolean,
    authLevel?: string, // for disabled tenant management
    appConfig?: IAppConfig
}

/**
 * Table for the tenant management in modal
 * @param scopes Scopes of the tenant management
 * @param removeScope Remove scope function
 * @param openEditScopeModal Open edit scope modal function
 * @param disabled Disable the replacement of the project guid with the display name
 * @param authLevel
 * @constructor
 */
const ModalTenantManagementTable: React.FC<ModalTenantManagementTableProps> = ({
                                                                                   scopes,
                                                                                   removeScope,
                                                                                   openEditScopeModal,
                                                                                   disabled,
                                                                                   authLevel,
                                                                                   appConfig
                                                                               }) => {
    // TODO: when switching from non tenant to tenant management, scopes are empty and the tenant system needs to be created

    /**
     * Prettify the scope path for user readability
     * @param scope Scope path
     */
    const prettierScopePath = (scope: string) => {
        if (scope === "user") {
            return "Global";
        }
        if (disabled) {
            return scope
        }
        const scopeParts = scope.split("/").map((part, index) => {
            return <GuidDisplayNameComponent scopes={scope.split('/')} position={index}
                                             globalLayer={HubPathRouting.currentProject == null}/> as unknown as string
        }).slice(1)

        // put / between each part
        // @ts-ignore
        return scopeParts.reduce((prev, curr) => [prev, " / ", curr])
    };

    const RoleTable = () => {

        const checkForValidRole = () => {
            // if the authlevel starts with { it is invalid
            return !authLevel.startsWith("{")
        }

        if (appConfig?.IsTenantManagementDisabled)
            return <tr key={42} className={"h-24"}>
                <td style={{width: '60%'}} className={"align-middle"}>

                </td>
                <td style={{width: '16%'}} className={"align-middle"}>
                    {checkForValidRole() ?
                        <OdxChip
                            content={authLevel}
                            size="small"
                            variant={odxVariants.secondary}
                            removable={false}
                        /> :
                        <OdxChip
                            content={"Invalid"}
                            size="small"
                            variant={odxVariants.danger}
                            removable={false}
                        />
                    }
                </td>
                <td style={{width: '12%'}} className={"align-middle"}>
                    <odx-icon-button
                        variant="ghost"
                        size="sm"
                        icon={`${odxIconSets.core}::edit`}
                        onClick={() => openEditScopeModal(undefined)}
                    />
                </td>
            </tr>
    }

    const TenantTable = () => {
        if (appConfig?.IsTenantManagementDisabled)
                return <>
                </>
        if (scopes)
            return scopes.map((scope, index) => (
                <tr id={"UserMng_EditUser_ScopeList_Row_" + simplifyForHtmlId(scope.fullscope)} key={index} className={"h-24"}>

                    {/* Scope name, e.g. "global" */}
                    <td style={{width: '60%'}} className={"align-middle"}>
                        {prettierScopePath(scope.fullscope)}
                    </td>

                    {/* Role, e.g. "admin" */}
                    <td style={{width: '16%'}} className={"align-middle"}>
                        <OdxChip
                            content={scope.value}
                            size="small"
                            id={"UserMng_EditUser_ScopeList_Role_" + simplifyForHtmlId(scope.fullscope)}
                            variant={odxVariants.secondary}
                            removable={false}
                        />
                    </td>

                    {/* edit button */}
                    <td style={{width: '12%'}} className={"align-middle"}>
                        <odx-icon-button
                            id={"EditScope_" + simplifyForHtmlId(scope.fullscope)}
                            variant="ghost"
                            size="sm"
                            icon={`${odxIconSets.core}::edit`}
                            onClick={() => openEditScopeModal(scope)}
                        />
                    </td>

                    {/* delete button */}
                    <td style={{width: '12%'}} className={"align-middle"}>
                        {scope.fullscope !== "user" && (
                            <odx-icon-button
                                variant="ghost"
                                size="sm"
                                id={"RemoveScope_" + simplifyForHtmlId(scope.fullscope)}
                                icon={`${odxIconSets.core}::delete`}
                                onClick={() => removeScope(index)}
                                className="!pr-0"
                            />
                        )}
                    </td>
                </tr>
            ))
    }

    return (
        <table id={"UserMng_EditUser_EditModalTable"} className={"w-full table-fixed"}>
             <tbody>
             <TenantTable/>
             <RoleTable/>
             </tbody>
         </table>
    )
}

export default ModalTenantManagementTable;
